import { type ClientDetailsFormData, clientDetailsFormSchema } from "Forms/Schemas/clientDetailsFormSchema";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import { parseBirthNumber } from "Infrastructure/Utils/ClientUtils";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, boolean, string } from "yup";

export type NewAnalysisFormData = ClientDetailsFormData & {
  readonly createMangoClient: boolean;
};

export const newAnalysisFormSchema = (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
): ObjectSchema<NewAnalysisFormData> =>
  clientDetailsFormSchema(t).shape({
    createMangoClient: boolean().required(),
    personalIdentificationNumber: string()
      .nullable()
      .when("createMangoClient", ([createMangoClient], schema) =>
        createMangoClient
          ? schema
              .required(t(Resources.Validation.Required))
              .test(
                "birth-number",
                t(Resources.Validation.InvalidPersonalIdentificationNumber),
                (value) => parseBirthNumber(value) !== null,
              )
          : schema,
      ),
  });
